import { useEffect, useState } from 'react';
import type { UrlObject } from 'url';

import {
  getActionAriaLabel,
  getAriaLabel,
  getFormAriaLabel,
  loadAriaLabels,
} from '@/utils/ariaLabels';

import { useRegionProvider } from '@/providers/RegionProvider';

export const useAriaLabels = () => {
  const { locale } = useRegionProvider();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const preloadAriaLabels = async () => {
      try {
        await loadAriaLabels(locale.code);
        setIsLoaded(true);
      } catch (error) {
        console.warn('Failed to load aria-labels:', error);
        setIsLoaded(true); // Still set to true to avoid infinite loading
      }
    };

    preloadAriaLabels();
  }, [locale.code]);

  const getUrlAriaLabel = async (
    url: UrlObject | string,
  ): Promise<string | undefined> => {
    return getAriaLabel(url, locale.code);
  };

  const getFormFieldAriaLabel = async (
    fieldKey: string,
  ): Promise<string | undefined> => {
    return getFormAriaLabel(fieldKey, locale.code);
  };

  const getActionButtonAriaLabel = async (
    actionKey: string,
  ): Promise<string | undefined> => {
    return getActionAriaLabel(actionKey, locale.code);
  };

  return {
    isLoaded,
    locale: locale.code,
    getUrlAriaLabel,
    getFormFieldAriaLabel,
    getActionButtonAriaLabel,
  };
};

export const useAriaLabelsSync = () => {
  const { locale } = useRegionProvider();

  return {
    locale: locale.code,
  };
};
